export default "__VITE_ASSET__BJjbrKvb__"